<div class="px-4 py-8 md:mt-12 dark:text-white">
  <div [dir]="languageDirection" class="text-center flex flex-col items-center">
    <h1 class="text-4xl md:text-6xl font-bold mb-4">
      {{ 'PROFESSIONALS.TITLE' | translate }}
    </h1>
    <p class="text-lg mb-8 sm:px-16 lg:px-48 text-gray-500 dark:text-gray-400">
      {{ 'PROFESSIONALS.TITLE-DESCRIPTION' | translate }}
    </p>
    <div class="flex w-full">
      <img
      ngSrc="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/berlin_bridge_md_florian_wehde_c29f188c2b.webp"
      priority
      srcset="
      https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/berlin_bridge_sm_florian_wehde1_1e48d26671.webp  640w,
      https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/berlin_bridge_md_florian_wehde_c29f188c2b.webp 1920w
      "
      sizes="(min-width: 1920px) 1920px,
       (min-width: 1540px) 1540px,
       (min-width: 1280px) 1280px,
       (min-width: 1040px) 1040px,
       (min-width: 780px) 780px,
       (min-width: 680px) 680px,
       100vw"
      alt="Berlin Brücke Fernsehturm"
      width="1920"
      height="1080"
      class="rounded-2xl"
      />
    </div>
  </div>

  <section [dir]="languageDirection" id="ourServices" class="py-12 sm:py-20">
    <div class="pb-4">
      <h1
        class="font-bold text-2xl md:text-4xl pb-4 text-center lg:ltr:text-left lg:rtl:text-right"
      >
        {{ 'PROFESSIONALS.OUR-SERVICES.TITLE' | translate }}
      </h1>
      <p class="text-gray-500 dark:text-gray-400">
        {{ 'PROFESSIONALS.OUR-SERVICES.TITLE-DESCRIPTION' | translate }}
      </p>
    </div>

    <div class="flex flex-col md:gap-16 text-gray-500 dark:text-gray-400">
      <div
        id="jobApplication"
        class="flex flex-col gap-4 justify-center items-center sm:flex-row my-10"
      >
        <div class="flex flex-col gap-4">
          <h1
            class="text-2xl font-semibold text-center text-black dark:text-white lg:ltr:text-left lg:rtl:text-right"
          >
            {{
              'PROFESSIONALS.OUR-SERVICES.FINDING-JOB-OFFER.TITLE' | translate
            }}
          </h1>
          <img
          src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/application_medium_09fdb6b2b5.webp"
          srcset="
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/application_small_3da3769b14.webp  640w,
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/application_medium_09fdb6b2b5.webp 1920w
          "
            sizes="(min-width: 780px) 728px, (min-width: 680px) 600px, calc(94.44vw - 23px)"
            width="1920"
            height="1283"
            alt="Finding a job offer"
            class="w-full md:hidden sm:h-1/2 lg:w-2/5 rounded-2xl"
          />
          <p>
            {{
              'PROFESSIONALS.OUR-SERVICES.FINDING-JOB-OFFER.DESCRIPTION'
                | translate
            }}
          </p>
          <h1 class="font-semibold">
            {{ 'PROFESSIONALS.OUR-SERVICES.YOUR-BENEFITS' | translate }}
          </h1>
          <ul class="space-y-1 list-disc list-inside">
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.FINDING-JOB-OFFER.FIRST-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.FINDING-JOB-OFFER.SECOND-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.FINDING-JOB-OFFER.THIRD-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.FINDING-JOB-OFFER.FOURTH-BENEFIT'
                  | translate
              }}
            </li>
          </ul>
        </div>
        <img
          src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/application_medium_09fdb6b2b5.webp"
          srcset="
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/application_small_3da3769b14.webp  640w,
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/application_medium_09fdb6b2b5.webp 1920w
          "
          sizes="(min-width: 1920px) 752px, (min-width: 1540px) 598px, (min-width: 1280px) 496px, 394px"
          width="1920"
          height="1283"
          alt="Finding a job offer"
          class="hidden md:block w-2/5 rounded-2xl"
        />
      </div>

      <div
        id="documentAssessment"
        class="flex flex-col gap-4 justify-center items-center sm:flex-row my-10"
      >
        <img
          src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/document_assessment_medium_40065b4f98.webp"
          srcset="
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/document_assessment_small_49cff84109.webp  640w,
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/document_assessment_medium_40065b4f98.webp 1920w
          "
          sizes="(min-width: 1920px) 752px, (min-width: 1540px) 598px, (min-width: 1280px) 496px, 394px"
          width="1920"
          height="1281"
          alt="Document Assessmen"
          class="hidden md:block w-2/5 rounded-2xl"
        />
        <div class="flex flex-col gap-4">
          <h1
            class="text-2xl font-semibold text-center text-black dark:text-white"
          >
            {{
              'PROFESSIONALS.OUR-SERVICES.DOCUMENT-ASSESSMENT.TITLE' | translate
            }}
          </h1>
          <img
            src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/document_assessment_medium_40065b4f98.webp"
            srcset="
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/document_assessment_small_49cff84109.webp  640w,
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/document_assessment_medium_40065b4f98.webp 1920w
            "
            sizes="(min-width: 780px) 728px, (min-width: 680px) 600px, calc(94.44vw - 23px)"
            width="1920"
            height="1281"
            alt="Document Assessmen"
            class="w-full md:hidden sm:h-1/2 lg:w-2/5 rounded-2xl"
          />
          <p>
            {{
              'PROFESSIONALS.OUR-SERVICES.DOCUMENT-ASSESSMENT.DESCRIPTION'
                | translate
            }}
          </p>
          <h1 class="font-semibold">
            {{ 'PROFESSIONALS.OUR-SERVICES.YOUR-BENEFITS' | translate }}
          </h1>
          <ul class="space-y-1 list-disc list-inside">
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.DOCUMENT-ASSESSMENT.FIRST-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.DOCUMENT-ASSESSMENT.SECOND-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.DOCUMENT-ASSESSMENT.THIRD-BENEFIT'
                  | translate
              }}
            </li>
          </ul>
        </div>
      </div>

      <div
        id="visaAssessment"
        class="flex flex-col gap-4 justify-center items-center sm:flex-row my-10"
      >
        <div class="flex flex-col gap-4">
          <h1
            class="text-2xl font-semibold text-center text-black dark:text-white"
          >
            {{ 'PROFESSIONALS.OUR-SERVICES.VISA-PROCESS.TITLE' | translate }}
          </h1>
          <img
            src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/visa_assessment_medium_3620d7aa0f.webp"
            srcset="
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/visa_assessment_small_b23e697817.webp  640w,
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/visa_assessment_medium_3620d7aa0f.webp 1920w
            "
            sizes="(min-width: 780px) 728px, (min-width: 680px) 600px, calc(94.44vw - 23px)"
            width="1920"
            height="1280"
            alt="Visa Process"
            class="w-full md:hidden sm:h-1/2 lg:w-2/5 rounded-2xl"
          />
          <p>
            {{
              'PROFESSIONALS.OUR-SERVICES.VISA-PROCESS.DESCRIPTION' | translate
            }}
          </p>
          <p class="font-semibold">
            {{ 'PROFESSIONALS.OUR-SERVICES.YOUR-BENEFITS' | translate }}
          </p>
          <ul class="space-y-1 list-disc list-inside">
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.VISA-PROCESS.FIRST-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.VISA-PROCESS.SECOND-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.VISA-PROCESS.THIRD-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.VISA-PROCESS.FOURTH-BENEFIT'
                  | translate
              }}
            </li>
          </ul>
        </div>
        <img
          src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/visa_assessment_medium_3620d7aa0f.webp"
          srcset="
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/visa_assessment_small_b23e697817.webp  640w,
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/visa_assessment_medium_3620d7aa0f.webp 1920w
          "
          sizes="(min-width: 1920px) 752px, (min-width: 1540px) 598px, (min-width: 1280px) 496px, 394px"
          width="1920"
          height="1280"
          alt="Visa Process"
          class="hidden md:block w-2/5 rounded-2xl"
        />
      </div>

      <div
        id="migrationProcess"
        class="flex flex-col gap-4 justify-center items-center sm:flex-row my-10"
      >
        <img
          src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/migration_process_medium_b6d6bfd92a.webp"
          srcset="
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/migration_process_small_66e09b8b49.webp  640w,
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/migration_process_medium_b6d6bfd92a.webp 1920w
          "
          sizes="(min-width: 1920px) 752px, (min-width: 1540px) 598px, (min-width: 1280px) 496px, 394px"
          width="1920"
          height="1080"
          alt="Migration Process"
          class="hidden md:block w-2/5 rounded-2xl"
        />
        <div class="flex flex-col gap-4">
          <h1
            class="text-2xl font-semibold text-center text-black dark:text-white"
          >
            {{
              'PROFESSIONALS.OUR-SERVICES.MIGRATION-PROCESS.TITLE' | translate
            }}
          </h1>
          <img
            src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/migration_process_medium_b6d6bfd92a.webp"
            srcset="
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/migration_process_small_66e09b8b49.webp  640w,
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/migration_process_medium_b6d6bfd92a.webp 1920w
            "
            sizes="(min-width: 780px) 728px, (min-width: 680px) 600px, calc(94.44vw - 23px)"
            width="1920"
            height="1080"
            alt="Migration Process"
            class="w-full md:hidden sm:h-1/2 lg:w-2/5 rounded-2xl"
          />
          <p>
            {{
              'PROFESSIONALS.OUR-SERVICES.MIGRATION-PROCESS.DESCRIPTION'
                | translate
            }}
          </p>
          <p class="font-semibold">
            {{ 'PROFESSIONALS.OUR-SERVICES.YOUR-BENEFITS' | translate }}
          </p>
          <ul class="space-y-1 list-disc list-inside">
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.MIGRATION-PROCESS.FIRST-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.MIGRATION-PROCESS.SECOND-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.MIGRATION-PROCESS.THIRD-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.MIGRATION-PROCESS.FOURTH-BENEFIT'
                  | translate
              }}
            </li>
          </ul>
        </div>
      </div>

      <div
        id="firstStep"
        class="flex flex-col gap-4 justify-center items-center sm:flex-row my-10"
      >
        <div class="flex flex-col gap-4">
          <h1
            class="text-2xl font-semibold text-center text-black dark:text-white"
          >
            {{ 'PROFESSIONALS.OUR-SERVICES.FIRST-STEPS.TITLE' | translate }}
          </h1>
          <img
            src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/first_step_medium_0ab6a77c04.webp"
            srcset="
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/first_step_small_95268996c0.webp  640w,
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/first_step_medium_0ab6a77c04.webp 1920w
            "
            sizes="(min-width: 780px) 728px, (min-width: 680px) 600px, calc(94.44vw - 23px)"
            width="1920"
            height="1280"
            alt="First steps in Germany"
            class="w-full md:hidden sm:h-1/2 lg:w-2/5 rounded-2xl"
          />
          <p>
            {{
              'PROFESSIONALS.OUR-SERVICES.FIRST-STEPS.DESCRIPTION' | translate
            }}
          </p>
          <p class="font-semibold">
            {{ 'PROFESSIONALS.OUR-SERVICES.YOUR-BENEFITS' | translate }}
          </p>
          <ul class="space-y-1 list-disc list-inside">
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.FIRST-STEPS.FIRST-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.FIRST-STEPS.SECOND-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.FIRST-STEPS.THIRD-BENEFIT'
                  | translate
              }}
            </li>
            <li>
              {{
                'PROFESSIONALS.OUR-SERVICES.FIRST-STEPS.FOURTH-BENEFIT'
                  | translate
              }}
            </li>
          </ul>
        </div>
        <img
          src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/first_step_medium_0ab6a77c04.webp"
          srcset="
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/first_step_small_95268996c0.webp  640w,
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/first_step_medium_0ab6a77c04.webp 1920w
          "
          sizes="(min-width: 1920px) 752px, (min-width: 1540px) 598px, (min-width: 1280px) 496px, 394px"
          width="1920"
          height="1280"
          alt="First steps in Germany"
          class="hidden md:block w-2/5 rounded-2xl"
        />
      </div>
    </div>
  </section>

  <section id="almanjobsAdvantages">
    <div [dir]="languageDirection" class="pb-12">
      <h1
        class="font-bold text-2xl md:text-4xl my-4 text-center lg:ltr:text-left lg:rtl:text-right"
      >
        {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TITLE' | translate }}
      </h1>
      <div
        class="text-gray-500 dark:text-gray-400 ltr:sm:text-left rtl:sm:text-right"
        [innerHTML]="
          'PROFESSIONALS.ALMANJOBS-ADVANTAGES.DESCRIPTION' | translate
        "
      ></div>
    </div>
    <div class="hidden sm:block relative overflow-x-auto shadow-md rounded-lg">
      <table class="w-full text-md text-gray-500 dark:text-gray-400">
        <thead
          [dir]="languageDirection"
          class="rtl:flex rtl:flex-row text-sm uppercase bg-gray-50 text-left rtl:text-right dark:bg-gray-600 text-black dark:text-white"
        >
          <tr class="rtl:flex rtl:text-right w-full">
            <th scope="col" class="px-6 py-3 rtl:w-1/3">
              {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.TITLE' | translate }}
            </th>
            <th scope="col" class="px-6 py-3 rtl:w-1/3">
              {{
                'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITH-ALMANJOBS' | translate
              }}
            </th>
            <th scope="col" class="px-6 py-3 rtl:w-1/3">
              {{
                'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITHOUT-ALMANJOBS'
                  | translate
              }}
            </th>
          </tr>
        </thead>
        <tbody [dir]="languageDirection" class="text-left rtl:text-right">
          <tr
            class="w-full rtl:flex rtl:flex-row rtl:text-right odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
          >
            <th
              class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4 sm:font-medium"
            >
              {{
                'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.FIND-JOB' | translate
              }}
            </th>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1">
                  <ng-icon
                    name="bootstrapCheckCircleFill"
                    class="text-blue-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate
                  }}
                </p>
              </div>
            </td>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1 scale-125">
                  <ng-icon
                    name="heroMinusCircleSolid"
                    class="text-gray-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.JOB-PLATFORMS'
                      | translate
                  }}
                </p>
              </div>
            </td>
          </tr>

          <tr
            class="w-full rtl:flex rtl:flex-row rtl:text-right odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
          >
            <th
              class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4 sm:font-medium"
            >
              {{
                'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.CHECK-ELIGIBILITY'
                  | translate
              }}
            </th>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1">
                  <ng-icon
                    name="bootstrapCheckCircleFill"
                    class="text-blue-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate
                  }}
                </p>
              </div>
            </td>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1 scale-125">
                  <ng-icon
                    name="heroMinusCircleSolid"
                    class="text-gray-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.EMBASSY-OR-AGANCY'
                      | translate
                  }}
                </p>
              </div>
            </td>
          </tr>

          <tr
            class="w-full rtl:flex rtl:flex-row rtl:text-right odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
          >
            <th
              class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4 font-medium"
            >
              {{
                'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.PREPARE-INTERVIEW'
                  | translate
              }}
            </th>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1">
                  <ng-icon
                    name="bootstrapCheckCircleFill"
                    class="text-blue-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TOGETHER' | translate
                  }}
                </p>
              </div>
            </td>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1 scale-125">
                  <ng-icon
                    name="heroMinusCircleSolid"
                    class="text-gray-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ON-YOUR-OWN' | translate
                  }}
                </p>
              </div>
            </td>
          </tr>

          <tr
            class="w-full rtl:flex rtl:flex-row rtl:text-right odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
          >
            <th
              class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4 sm:font-medium"
            >
              {{
                'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.NEGOTIATE-CONDITIONS'
                  | translate
              }}
            </th>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1">
                  <ng-icon
                    name="bootstrapCheckCircleFill"
                    class="text-blue-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate
                  }}
                </p>
              </div>
            </td>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1 scale-125">
                  <ng-icon
                    name="heroMinusCircleSolid"
                    class="text-gray-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ON-YOUR-OWN' | translate
                  }}
                </p>
              </div>
            </td>
          </tr>

          <tr
            class="w-full rtl:flex rtl:flex-row rtl:text-right odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
          >
            <th
              class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4 sm:font-medium"
            >
              {{
                'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.ANNERKENNUNG'
                  | translate
              }}
            </th>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1">
                  <ng-icon
                    name="bootstrapCheckCircleFill"
                    class="text-blue-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TOGETHER' | translate
                  }}
                </p>
              </div>
            </td>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1 scale-125">
                  <ng-icon
                    name="heroMinusCircleSolid"
                    class="text-gray-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ANABIN-OR-ZAB'
                      | translate
                  }}
                </p>
              </div>
            </td>
          </tr>

          <tr
            class="w-full rtl:flex rtl:flex-row rtl:text-right odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
          >
            <th
              class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4 sm:font-medium"
            >
              {{
                'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.PREPARE-DOCUMENTS'
                  | translate
              }}
            </th>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1">
                  <ng-icon
                    name="bootstrapCheckCircleFill"
                    class="text-blue-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate
                  }}
                </p>
              </div>
            </td>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1 scale-125">
                  <ng-icon
                    name="heroMinusCircleSolid"
                    class="text-gray-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ON-YOUR-OWN' | translate
                  }}
                </p>
              </div>
            </td>
          </tr>

          <tr
            class="w-full rtl:flex rtl:flex-row rtl:text-right odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
          >
            <th
              class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4 sm:font-medium"
            >
              {{
                'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.FIND-FLAT' | translate
              }}
            </th>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1">
                  <ng-icon
                    name="bootstrapCheckCircleFill"
                    class="text-blue-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TOGETHER' | translate
                  }}
                </p>
              </div>
            </td>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1 scale-125">
                  <ng-icon
                    name="heroMinusCircleSolid"
                    class="text-gray-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.IMMO-PLATFORMS'
                      | translate
                  }}
                </p>
              </div>
            </td>
          </tr>

          <tr
            class="w-full rtl:flex rtl:flex-row odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
          >
            <th
              class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4 sm:font-medium"
            >
              {{
                'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.PICKUP' | translate
              }}
            </th>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1">
                  <ng-icon
                    name="bootstrapCheckCircleFill"
                    class="text-blue-500"
                  ></ng-icon>
                </div>
                <h1>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate
                  }}
                </h1>
              </div>
            </td>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1 scale-125">
                  <ng-icon
                    name="heroMinusCircleSolid"
                    class="text-gray-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ON-YOUR-OWN' | translate
                  }}
                </p>
              </div>
            </td>
          </tr>

          <tr
            class="w-full rtl:flex rtl:flex-row odd:bg-white odd:dark:bg-gray-900 even:bg-gray-50 even:dark:bg-gray-800 border-b dark:border-gray-700"
          >
            <th
              class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4 sm:font-medium"
            >
              {{
                'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.POST-ARRIVAL'
                  | translate
              }}
            </th>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2">
                  <ng-icon
                    name="bootstrapCheckCircleFill"
                    class="text-blue-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate
                  }}
                </p>
              </div>
            </td>
            <td class="rtl:flex rtl:items-center rtl:w-1/3 px-6 py-4">
              <div class="flex flex-row items-center">
                <div class="px-2 pt-1 scale-125">
                  <ng-icon
                    name="heroMinusCircleSolid"
                    class="text-gray-500"
                  ></ng-icon>
                </div>
                <p>
                  {{
                    'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ON-YOUR-OWN' | translate
                  }}
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div [dir]="languageDirection" class="sm:hidden grid grid-cols-1 pb-36">
      <div
        class="flex flex-col justify-center gap-4 border-y-[1px] border-black dark:border-white mx-4 py-6"
      >
        <h1 class="flex justify-center text-lg font-semibold">
          {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.FIND-JOB' | translate }}
        </h1>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <p class="w-full max-w-[50%] text-center px-2">
            {{
              'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITH-ALMANJOBS' | translate
            }}
          </p>
          <p class="w-full max-w-[50%] text-center px-2">
            {{
              'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITHOUT-ALMANJOBS' | translate
            }}
          </p>
        </div>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <div
            class="flex items-center justify-center w-full max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="bootstrapCheckCircleFill"
                  class="text-blue-500"
                ></ng-icon>
              </div>
              <p>
                {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate }}
              </p>
            </div>
          </div>
          <div
            class="w-full flex items-center justify-center max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="heroMinusCircleSolid"
                  class="text-gray-500 scale-125"
                ></ng-icon>
              </div>
              <p>
                {{
                  'PROFESSIONALS.ALMANJOBS-ADVANTAGES.JOB-PLATFORMS' | translate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col gap-4 border-b-[1px] border-black dark:border-white mx-4 py-6"
      >
        <h1 class="flex justify-center text-lg font-semibold">
          {{
            'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.CHECK-ELIGIBILITY'
              | translate
          }}
        </h1>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <p class="w-full max-w-[50%] text-center px-2">
            {{
              'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITH-ALMANJOBS' | translate
            }}
          </p>
          <p class="w-full max-w-[50%] text-center px-2">
            {{
              'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITHOUT-ALMANJOBS' | translate
            }}
          </p>
        </div>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <div
            class="flex items-center justify-center w-full max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="bootstrapCheckCircleFill"
                  class="text-blue-500"
                ></ng-icon>
              </div>
              <p>
                {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate }}
              </p>
            </div>
          </div>
          <div
            class="w-full flex items-center justify-center max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="heroMinusCircleSolid"
                  class="text-gray-500 scale-125"
                ></ng-icon>
              </div>
              <p>
                {{
                  'PROFESSIONALS.ALMANJOBS-ADVANTAGES.EMBASSY-OR-AGANCY'
                    | translate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col gap-4 border-b-[1px] border-black dark:border-white mx-4 py-6"
      >
        <h1 class="flex justify-center text-lg font-semibold">
          {{
            'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.PREPARE-INTERVIEW'
              | translate
          }}
        </h1>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <p class="w-full max-w-[50%] text-center px-2">
            {{
              'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITH-ALMANJOBS' | translate
            }}
          </p>
          <p class="w-full max-w-[50%] text-center px-2">
            {{
              'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITHOUT-ALMANJOBS' | translate
            }}
          </p>
        </div>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <div
            class="flex items-center justify-center w-full max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="bootstrapCheckCircleFill"
                  class="text-blue-500"
                ></ng-icon>
              </div>
              <p>
                {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TOGETHER' | translate }}
              </p>
            </div>
          </div>
          <div
            class="w-full flex items-center justify-center max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="heroMinusCircleSolid"
                  class="text-gray-500 scale-125"
                ></ng-icon>
              </div>
              <p>
                {{
                  'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ON-YOUR-OWN' | translate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col gap-4 border-b-[1px] border-black dark:border-white mx-4 py-6"
      >
        <h1 class="flex justify-center text-lg font-semibold">
          {{
            'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.NEGOTIATE-CONDITIONS'
              | translate
          }}
        </h1>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <p class="w-full max-w-[50%] text-center px-2">
            {{
              'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITH-ALMANJOBS' | translate
            }}
          </p>
          <p class="w-full max-w-[50%] text-center px-2">
            {{
              'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITHOUT-ALMANJOBS' | translate
            }}
          </p>
        </div>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <div
            class="flex items-center justify-center w-full max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="bootstrapCheckCircleFill"
                  class="text-blue-500"
                ></ng-icon>
              </div>
              <p>
                {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate }}
              </p>
            </div>
          </div>
          <div
            class="w-full flex items-center justify-center max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="heroMinusCircleSolid"
                  class="text-gray-500 scale-125"
                ></ng-icon>
              </div>
              <p>
                {{
                  'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ON-YOUR-OWN' | translate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col gap-4 border-b-[1px] border-black dark:border-white mx-4 py-6"
      >
        <h1 class="flex justify-center text-lg font-semibold">
          {{
            'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.ANNERKENNUNG' | translate
          }}
        </h1>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <p class="w-full max-w-[50%] text-center px-2">
            {{
              'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITH-ALMANJOBS' | translate
            }}
          </p>
          <p class="w-full max-w-[50%] text-center px-2">
            {{
              'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITHOUT-ALMANJOBS' | translate
            }}
          </p>
        </div>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <div
            class="flex items-center justify-center w-full max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="bootstrapCheckCircleFill"
                  class="text-blue-500"
                ></ng-icon>
              </div>
              <p>
                {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TOGETHER' | translate }}
              </p>
            </div>
          </div>
          <div
            class="w-full flex items-center justify-center max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="heroMinusCircleSolid"
                  class="text-gray-500 scale-125"
                ></ng-icon>
              </div>
              <p>
                {{
                  'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ANABIN-OR-ZAB' | translate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col gap-4 border-b-[1px] border-black dark:border-white mx-4 py-6"
      >
        <h1 class="flex justify-center text-lg font-semibold">
          {{
            'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.PREPARE-DOCUMENTS'
              | translate
          }}
        </h1>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <p class="w-full max-w-[50%] text-center px-2">
            {{
              'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITH-ALMANJOBS' | translate
            }}
          </p>
          <p class="w-full max-w-[50%] text-center px-2">
            {{
              'PROFESSIONALS.ALMANJOBS-ADVANTAGES.WITHOUT-ALMANJOBS' | translate
            }}
          </p>
        </div>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <div
            class="flex items-center justify-center w-full max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="bootstrapCheckCircleFill"
                  class="text-blue-500"
                ></ng-icon>
              </div>
              <p>
                {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate }}
              </p>
            </div>
          </div>
          <div
            class="w-full flex items-center justify-center max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="heroMinusCircleSolid"
                  class="text-gray-500 scale-125"
                ></ng-icon>
              </div>
              <p>
                {{
                  'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ON-YOUR-OWN' | translate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col gap-4 border-b-[1px] border-black dark:border-white mx-4 py-6"
      >
        <h1 class="flex justify-center text-lg font-semibold">
          {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.FIND-FLAT' | translate }}
        </h1>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <p class="w-full max-w-[50%] text-center px-2">
            {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate }}
          </p>
          <p class="w-full max-w-[50%] text-center px-2">
            {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ON-YOUR-OWN' | translate }}
          </p>
        </div>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <div
            class="flex items-center justify-center w-full max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="bootstrapCheckCircleFill"
                  class="text-blue-500"
                ></ng-icon>
              </div>
              <p>
                {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TOGETHER' | translate }}
              </p>
            </div>
          </div>
          <div
            class="w-full flex items-center justify-center max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="heroMinusCircleSolid"
                  class="text-gray-500 scale-125"
                ></ng-icon>
              </div>
              <p>
                {{
                  'PROFESSIONALS.ALMANJOBS-ADVANTAGES.IMMO-PLATFORMS'
                    | translate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col gap-4 border-b-[1px] border-black dark:border-white mx-4 py-6"
      >
        <h1 class="flex justify-center text-lg font-semibold">
          {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.PICKUP' | translate }}
        </h1>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <p class="w-full max-w-[50%] text-center px-2">
            {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate }}
          </p>
          <p class="w-full max-w-[50%] text-center px-2">
            {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ON-YOUR-OWN' | translate }}
          </p>
        </div>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <div
            class="flex items-center justify-center w-full max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="bootstrapCheckCircleFill"
                  class="text-blue-500"
                ></ng-icon>
              </div>
              <p>
                {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate }}
              </p>
            </div>
          </div>
          <div
            class="w-full flex items-center justify-center max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="heroMinusCircleSolid"
                  class="text-gray-500 scale-125"
                ></ng-icon>
              </div>
              <p>
                {{
                  'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ON-YOUR-OWN' | translate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="flex flex-col gap-4 border-b-[1px] border-black dark:border-white mx-4 py-6"
      >
        <h1 class="flex justify-center text-lg font-semibold">
          {{
            'PROFESSIONALS.ALMANJOBS-ADVANTAGES.TASKS.POST-ARRIVAL' | translate
          }}
        </h1>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <p class="w-full max-w-[50%] text-center px-2">
            {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate }}
          </p>
          <p class="w-full max-w-[50%] text-center px-2">
            {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ON-YOUR-OWN' | translate }}
          </p>
        </div>
        <div
          class="flex flex-row justify-between text-gray-500 dark:text-gray-400"
        >
          <div
            class="flex items-center justify-center w-full max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="bootstrapCheckCircleFill"
                  class="text-blue-500"
                ></ng-icon>
              </div>
              <p>
                {{ 'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ALMANJOBS' | translate }}
              </p>
            </div>
          </div>
          <div
            class="w-full flex items-center justify-center max-w-[50%] text-center"
          >
            <div class="flex flex-row items-center">
              <div class="px-2 pt-1">
                <ng-icon
                  name="heroMinusCircleSolid"
                  class="text-gray-500 scale-125"
                ></ng-icon>
              </div>
              <p>
                {{
                  'PROFESSIONALS.ALMANJOBS-ADVANTAGES.ON-YOUR-OWN' | translate
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section [dir]="languageDirection" class="my-4 sm:my-20">
    <div class="flex flex-col gap-4">
      <h1
        class="font-bold text-2xl md:text-4xl text-center ltr:xs:text-left rlt:xs:text-right my-4"
      >
        {{ 'PROFESSIONALS.WHY-GERMANY' | translate }}
      </h1>
      <div class="flex w-full max-h-[30rem]">
        <img
          src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/frankfurt_md_tobias_reich_2abd196c9b.webp"
          srcset="
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/frankfurt_sm_tobias_reich_b857668208.webp  640w,
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/frankfurt_md_tobias_reich_2abd196c9b.webp 1920w
          "
          sizes="(min-width: 1920px) 1880px, (min-width: 1540px) 1496px, (min-width: 1280px) 1240px, (min-width: 1040px) 984px, (min-width: 780px) 728px, (min-width: 680px) 600px, calc(94.44vw - 23px)"
          width="1920"
          height="1080"
          alt="Frankfurt Skyline"
          loading="lazy"
          class="rounded-2xl"
        />
      </div>
      <p class="text-gray-500 dark:text-gray-400">
        {{ 'PROFESSIONALS.WHY-GERMANY-DESCRIPTION' | translate }}
      </p>
    </div>
  </section>

  <div class="timeline">
    <h1 [dir]="languageDirection"
      class="font-bold text-2xl md:text-4xl text-center ltr:xs:text-left rlt:xs:text-right my-4"
    >
      {{ 'PROFESSIONALS.NEXT-STEPS.TITLE' | translate }}
    </h1>
    <p [dir]="languageDirection" class="text-gray-500 dark:text-gray-400">
      {{ 'PROFESSIONALS.NEXT-STEPS.DESCRIPTION' | translate }}
    </p>
    <div class="flex justify-center align-middle py-8">
      <div class="outer w-full sm:w-[80%]">
        <!-- Step 1 -->
        <div [dir]="languageDirection" class="card flex flex-row">
          <div
            class="info p-4 md:p-10 bg-gray-100 dark:bg-gray-700 rounded-2xl mr-8"
          >
            <div class="flex flex-row items-center gap-2 mb-2">
              <img
                src="/assets/icons/employees/register-and-fill-data.svg"
                alt=""
                class="w-10 h-10"
                [class.grey-svg]="(activeTheme$ | async) === 'dark'"
              />
              <h3 class="title text-1xl md:text-2xl font-semibold">
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-1.TITLE' | translate }}
              </h3>
            </div>
            <p class="mb-4 text-xs md:text-base">
              {{ 'PROFESSIONALS.NEXT-STEPS.STEP-1.DESCRIPTION' | translate }}
            </p>
            <ul
              class="list-disc text-xs md:text-base list-inside text-gray-700 dark:text-gray-400"
            >
              <li>
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-1.SUBSET-1' | translate }}
              </li>
              <li>
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-1.SUBSET-2' | translate }}
              </li>
            </ul>
            <div class="flex w-full justify-center items-center"></div>
          </div>
        </div>

        <!-- Step 2 -->
        <div [dir]="languageDirection" class="card flex flex-row">
          <div
            class="info p-4 md:p-10 bg-gray-100 dark:bg-gray-700 rounded-2xl ml-8"
          >
            <div class="flex flex-row items-center gap-2 mb-2">
              <img
                src="/assets/icons/employees/apply-and-job-interview.svg"
                alt=""
                class="w-10 h-10"
                [class.grey-svg]="(activeTheme$ | async) === 'dark'"
              />
              <h3 class="title text-1xl md:text-2xl font-semibold">
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-2.TITLE' | translate }}
              </h3>
            </div>
            <p class="mb-4 text-xs md:text-base">
              {{ 'PROFESSIONALS.NEXT-STEPS.STEP-2.DESCRIPTION' | translate }}
            </p>
            <ul
              class="list-disc text-xs md:text-base list-inside text-gray-700 dark:text-gray-400"
            >
              <li>
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-2.SUBSET-1' | translate }}
              </li>
              <li>
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-2.SUBSET-2' | translate }}
              </li>
              <li>
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-2.SUBSET-3' | translate }}
              </li>
            </ul>
            <div class="flex w-full justify-center items-center"></div>
          </div>
        </div>

        <!-- Step 3 -->
        <div [dir]="languageDirection" class="card flex flex-row">
          <div
            class="info p-4 md:p-10 bg-gray-100 dark:bg-gray-700 rounded-2xl mr-8"
          >
            <div class="flex flex-row items-center gap-2 mb-2">
              <img
                src="/assets/icons/employees/apply-for-visa.svg"
                alt=""
                class="w-10 h-10"
                [class.grey-svg]="(activeTheme$ | async) === 'dark'"
              />
              <h3 class="title text-1xl md:text-2xl font-semibold">
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-3.TITLE' | translate }}
              </h3>
            </div>
            <p class="mb-4 text-xs md:text-base">
              {{ 'PROFESSIONALS.NEXT-STEPS.STEP-3.DESCRIPTION' | translate }}
            </p>
            <ul
              class="list-disc text-xs md:text-base list-inside text-gray-700 dark:text-gray-400"
            >
              <li>
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-3.SUBSET-1' | translate }}
              </li>
              <li>
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-3.SUBSET-2' | translate }}
              </li>
              <li>
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-3.SUBSET-3' | translate }}
              </li>
            </ul>
            <div class="flex w-full justify-center items-center"></div>
          </div>
        </div>

        <!-- Step 4 -->
        <div [dir]="languageDirection" class="card flex flex-row">
          <div
            class="info p-4 md:p-10 bg-gray-100 dark:bg-gray-700 rounded-2xl ml-8"
          >
            <div class="flex flex-row items-center gap-2 mb-2">
              <img
                src="/assets/icons/employees/migrate.svg"
                alt=""
                class="w-10 h-10"
                [class.grey-svg]="(activeTheme$ | async) === 'dark'"
              />
              <h3 class="title text-1xl md:text-2xl font-semibold">
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-4.TITLE' | translate }}
              </h3>
            </div>
            <p class="mb-4 text-xs md:text-base">
              {{ 'PROFESSIONALS.NEXT-STEPS.STEP-4.DESCRIPTION' | translate }}
            </p>
            <ul
              class="list-disc text-xs md:text-base list-inside text-gray-700 dark:text-gray-400"
            >
              <li>
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-4.SUBSET-1' | translate }}
              </li>
              <li>
                {{ 'PROFESSIONALS.NEXT-STEPS.STEP-4.SUBSET-2' | translate }}
              </li>
            </ul>
            <div class="flex w-full justify-center items-center"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div [dir]="languageDirection" class="text-center py-8 my-24 flex flex-col items-center">
    <h3 class="text-4xl font-bold mb-4">
      {{ 'PROFESSIONALS.MAKE-MOVE-TITLE' | translate }}
    </h3>
    <p class="text-lg mb-8 text-gray-700 dark:text-gray-300 max-w-4xl">
      {{ 'PROFESSIONALS.MAKE-MOVE-DESCRIPTION' | translate }}
    </p>
    <a
      type="button"
      class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
      [routerLink]="['', 'auth', 'register']"
    >
      {{ 'PROFESSIONALS.MAKE-MOVE-BUTTON' | translate }}
    </a>
  </div>
</div>
